module.exports = __webpack_public_path__ + "img/citi_logo.21762ed3.png";